export default __webpack_public_path__ + "static/media/DSC_7700.41f0a1bd.jpg";